import { render, staticRenderFns } from "./DirectorySection.vue?vue&type=template&id=624e3599&scoped=true&"
import script from "./DirectorySection.vue?vue&type=script&lang=js&"
export * from "./DirectorySection.vue?vue&type=script&lang=js&"
import style0 from "./DirectorySection.vue?vue&type=style&index=0&id=624e3599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624e3599",
  null
  
)

export default component.exports